import { sb } from '../supabase.ts';

export async function renderAdmissionPage(app: HTMLElement) {
  app.innerHTML = `
<style>
  .admin-wrap { background: #f1f5f9; min-height: 100vh; padding: 24px; }
  .admin-card { background: #fff; border-radius: 12px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); overflow: hidden; }
  .admin-header { padding: 20px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; background: #fff; }
  .admin-header h2 { font-size: 18px; font-weight: 700; color: #1e293b; margin: 0; }
  
  .filters { padding: 16px 20px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; display: flex; gap: 12px; flex-wrap: wrap; align-items: center; }
  .filters select, .filters input { padding: 8px 12px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 14px; min-width: 150px; }
  
  .table-container { width: 100%; overflow-x: auto; }
  table { width: 100%; border-collapse: collapse; font-size: 13px; }
  th { background: #f8fafc; padding: 12px; text-align: left; border-bottom: 1px solid #e2e8f0; color: #475569; font-weight: 600; text-transform: uppercase; font-size: 11px; }
  td { padding: 12px; border-bottom: 1px solid #f1f5f9; color: #1e293b; }
  tr:hover { background: #fdfdfd; }
  
  .photo-sm { width: 40px; height: 50px; border-radius: 4px; object-fit: cover; border: 1px solid #e2e8f0; }
  .badge { padding: 2px 8px; border-radius: 999px; font-size: 11px; font-weight: 600; }
  .badge.active { background: #dcfce7; color: #166534; }
  
  .loading-overlay { padding: 40px; text-align: center; color: #64748b; }
</style>

<div class="admin-wrap">
  <div class="container">
    <div class="admin-card">
      <div class="admin-header">
        <h2>Admission Management</h2>
        <div id="stats" style="font-size: 13px; color: #64748b;"></div>
      </div>
      
      <div class="filters">
        <select id="sessionFilter">
          <option value="2025">Session 2025</option>
          <option value="2026" selected>Session 2026</option>
          <option value="2027">Session 2027</option>
        </select>
        <select id="classFilter">
          <option value="">All Classes</option>
          <option value="6">Class 6</option>
          <option value="7">Class 7</option>
          <option value="8">Class 8</option>
          <option value="9">Class 9</option>
          <option value="10">Class 10</option>
        </select>
        <select id="sectionFilter">
          <option value="">All Sections</option>
          <option value="MORNING">MORNING</option>
          <option value="DAY">DAY</option>
          <option value="SHAPLA">SHAPLA</option>
          <option value="GOLAP">GOLAP</option>
        </select>
        <input type="text" id="searchInput" placeholder="Search name or IID...">
      </div>
      
      <div class="table-container" id="tableBody">
        <div class="loading-overlay">Loading student records...</div>
      </div>
    </div>
  </div>
</div>
  `;

  const tableBody = document.getElementById('tableBody')!;
  const sessionFilter = document.getElementById('sessionFilter') as HTMLSelectElement;
  const classFilter = document.getElementById('classFilter') as HTMLSelectElement;
  const sectionFilter = document.getElementById('sectionFilter') as HTMLSelectElement;
  const searchInput = document.getElementById('searchInput') as HTMLInputElement;
  const statsEl = document.getElementById('stats')!;

  async function loadData() {
    tableBody.innerHTML = '<div class="loading-overlay">Fetching data...</div>';
    
    const session = sessionFilter.value;
    const cls = classFilter.value;
    const sec = sectionFilter.value;
    const search = searchInput.value.toLowerCase();
    
    const clsCol = `class_${session}`;
    const secCol = `section_${session}`;
    const rollCol = `roll_${session}`;

    let query = sb.from('student_database').select(`
      iid, student_name_en, father_name_en, father_mobile, 
      ${clsCol}, ${secCol}, ${rollCol}, student_photo_url, status, admission_date
    `).order(clsCol).order(secCol).order(rollCol);

    if (cls) query = query.eq(clsCol, cls);
    if (sec) query = query.eq(secCol, sec);

    const { data, error } = await query;

    if (error) {
      tableBody.innerHTML = `<div class="loading-overlay" style="color:red;">Error: ${error.message}</div>`;
      return;
    }

    let filtered = (data as any[]) || [];
    if (search) {
      filtered = filtered.filter(s => 
        String(s.student_name_en).toLowerCase().includes(search) || 
        String(s.iid).includes(search)
      );
    }

    statsEl.textContent = `Showing ${filtered.length} students`;

    if (filtered.length === 0) {
      tableBody.innerHTML = '<div class="loading-overlay">No records found.</div>';
      return;
    }

    tableBody.innerHTML = `
      <table>
        <thead>
          <tr>
            <th>Photo</th>
            <th>IID / Roll</th>
            <th>Student Name</th>
            <th>Father's Name</th>
            <th>Mobile</th>
            <th>Class / Section</th>
            <th>Adm. Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          ${filtered.map(s => `
            <tr>
              <td><img src="${s.student_photo_url || 'https://via.placeholder.com/40x50'}" class="photo-sm"></td>
              <td>
                <div style="font-weight:700;">${s.iid}</div>
                <div style="font-size:11px; color:#64748b;">Roll: ${s[rollCol] || 'N/A'}</div>
              </td>
              <td>${s.student_name_en || 'N/A'}</td>
              <td>${s.father_name_en || 'N/A'}</td>
              <td>${s.father_mobile || 'N/A'}</td>
              <td>
                <div>Class ${s[clsCol] || 'N/A'}</div>
                <div style="font-size:11px; color:#64748b;">${s[secCol] || 'N/A'}</div>
              </td>
              <td>${s.admission_date || 'N/A'}</td>
              <td><span class="badge active">${s.status || 'Active'}</span></td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    `;
  }

  sessionFilter.onchange = loadData;
  classFilter.onchange = loadData;
  sectionFilter.onchange = loadData;
  searchInput.oninput = loadData;

  loadData();
}
